import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faClock,
  faFilter,
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";

import { APISD } from "../../../../../../../config/apisd";
import { APIMS } from "../../../../../../../config/apims";
import ToastError from "../../../../../../NotificationToast/ToastError";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";

import "bulma/css/bulma.css";
import "../../../../../../../index.css";

const pageStyles = `
  @keyframes pjShimmer {
    0% { background-position: -700px 0; }
    100% { background-position: 700px 0; }
  }

  .pj-page {
    width: 100%;
    padding: 4px 0 28px;
  }

  .pj-filter-card {
    width: 100%;
    margin-bottom: 18px;
    padding: 0 18px 18px 18px;
    
    border: 1px solid #e6ebf4;
    border-radius: 14px;
    background: #ffffff;
    box-shadow: 0 4px 18px rgba(39, 71, 140, 0.06);
  }

  .pj-filter-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
  }

  .pj-filter-title-wrap {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 10px;
  }

  .pj-filter-icon {
    display: inline-flex;
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #edf4ff;
    color: #315fba;
  }

  .pj-filter-title {
    margin: 0;
    color: #1f2a44;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
  }

  .pj-filter-subtitle {
    margin: 2px 0 0;
    color: #8a96aa;
    font-size: 12px;
    line-height: 1.35;
  }

  .pj-filter-grid {
    display: grid;
    // grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-columns:
      minmax(190px, 0.9fr)
      minmax(240px, 1.2fr)
      minmax(190px, 0.9fr)
      auto;
    gap: 14px 12px;
    align-items: end;
  }

  .pj-field {
    min-width: 0;
  }

  .pj-label {
    display: block;
    margin-bottom: 7px;
    color: #4c5870;
    font-size: 12px;
    font-weight: 700;
  }

  .pj-select-wrap {
    position: relative;
  }

  .pj-select-wrap::after {
    position: absolute;
    top: 50%;
    right: 13px;
    width: 7px;
    height: 7px;
    border-right: 1.7px solid #72809a;
    border-bottom: 1.7px solid #72809a;
    content: "";
    pointer-events: none;
    transform: translateY(-68%) rotate(45deg);
  }

  .pj-select {
    width: 100%;
    height: 42px;
    padding: 0 36px 0 12px;
    border: 1px solid #dce3ef;
    border-radius: 9px;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    background: #ffffff;
    color: #2f3a50;
    font-size: 13px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  }

  .pj-select:hover:not(:disabled) {
    border-color: #b9c9e7;
  }

  .pj-select:focus {
    border-color: #4c78d3;
    box-shadow: 0 0 0 3px rgba(76, 120, 211, 0.12);
  }

  .pj-select:disabled {
    cursor: not-allowed;
    background: #f6f8fb;
    color: #9aa5b6;
  }

  .pj-filter-button {
    display: inline-flex;
    width: 100%;
    min-height: 42px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 16px;
    border: 1px solid #e9a51a;
    border-radius: 9px;
    background: #e9a51a;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    box-shadow: 0 4px 10px rgba(233, 165, 26, 0.2);
    transition: transform 0.15s ease, box-shadow 0.2s ease, background 0.2s ease;
  }

  .pj-filter-button:hover:not(:disabled) {
    background: #d89512;
    border-color: #d89512;
    transform: translateY(-1px);
  }

  .pj-filter-button:disabled {
    cursor: not-allowed;
    border-color: #cbd2df;
    background: #cbd2df;
    box-shadow: none;
  }

  .pj-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin: 18px 0 12px;
  }

  .pj-search-wrap {
    position: relative;
    width: min(100%, 360px);
  }

  .pj-search-icon {
    position: absolute;
    top: 50%;
    left: 14px;
    z-index: 1;
    color: #8c98ab;
    pointer-events: none;
    transform: translateY(-50%);
  }

  .pj-search-input {
    width: 100%;
    height: 42px;
    padding: 0 14px 0 40px;
    border: 1px solid #dce3ef;
    border-radius: 10px;
    outline: none;
    background: #ffffff;
    color: #27334a;
    font-size: 13px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .pj-search-input::placeholder {
    color: #a1aaba;
  }

  .pj-search-input:focus {
    border-color: #4c78d3;
    box-shadow: 0 0 0 3px rgba(76, 120, 211, 0.11);
  }

  .pj-toolbar-right {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 10px;
  }

  .pj-total-badge {
    display: inline-flex;
    min-height: 34px;
    align-items: center;
    padding: 7px 11px;
    border: 1px solid #e1e7f1;
    border-radius: 8px;
    background: #f8faff;
    color: #64718a;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }

  .pj-add-button {
    display: inline-flex;
    min-height: 40px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 15px;
    border: 1px solid #3768c5;
    border-radius: 9px;
    background: #3768c5;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 4px 12px rgba(55, 104, 197, 0.18);
    transition: transform 0.15s ease, background 0.2s ease;
  }

  .pj-add-button:hover {
    background: #2e59aa;
    border-color: #2e59aa;
    transform: translateY(-1px);
  }

  .pj-table {
    min-width: 820px;
  }

  .pj-col-time {
    width: 150px;
  }

  .pj-col-limit {
    width: 190px;
  }

  .pj-col-note {
    width: auto;
  }

  .pj-time-badge {
    display: inline-flex;
    min-width: 82px;
    min-height: 30px;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 5px 10px;
    border: 1px solid #dce7fb;
    border-radius: 8px;
    background: #f3f7ff;
    color: #315fba;
    font-size: 12.5px;
    font-weight: 700;
  }

  .pj-limit-text {
    color: #4c5870;
    font-size: 13px;
    font-weight: 600;
  }

  .pj-shimmer {
    position: relative;
    overflow: hidden;
    background: linear-gradient(90deg, #e9eff8 8%, #f7f9fd 18%, #e9eff8 33%);
    background-size: 1100px 100%;
    animation: pjShimmer 1.25s linear infinite;
  }

  .pj-shimmer-label {
    width: 72px;
    height: 10px;
    margin-bottom: 8px;
    border-radius: 5px;
  }

  .pj-shimmer-control {
    width: 100%;
    height: 42px;
    border-radius: 9px;
  }

  .pj-loading-card {
    overflow: hidden;
    border: 1px solid #e6ebf4;
    border-radius: 14px;
    background: #ffffff;
  }

  .pj-loading-head {
    height: 54px;
    border-bottom: 1px solid #e5ebf4;
    background: #edf4ff;
  }

  .pj-loading-row {
    display: grid;
    grid-template-columns: 70px 150px 150px 190px 1fr 130px;
    gap: 14px;
    min-width: 820px;
    align-items: center;
    padding: 14px 18px;
    border-bottom: 1px solid #edf0f5;
  }

  .pj-loading-row:last-child {
    border-bottom: 0;
  }

  .pj-loading-line {
    height: 12px;
    border-radius: 6px;
  }

  .pj-loading-line.short { width: 30px; justify-self: center; }
  .pj-loading-line.medium { width: 72%; }
  .pj-loading-line.action { width: 38px; justify-self: center; }

  @media (max-width: 1050px) {
    .pj-filter-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 780px) {
    .pj-page {
      padding-top: 0;
    }

    .pj-filter-card {
      padding: 15px;
      border-radius: 12px;
    }

    .pj-filter-header {
      align-items: flex-start;
      margin-bottom: 14px;
    }

    .pj-filter-grid {
      grid-template-columns: 1fr;
      gap: 11px;
    }

    .pj-toolbar {
      align-items: stretch;
      flex-direction: column;
      gap: 10px;
      margin-top: 16px;
    }

    .pj-search-wrap,
    .pj-toolbar-right {
      width: 100%;
    }

    .pj-toolbar-right {
      justify-content: space-between;
    }

    .pj-add-button {
      flex: 1;
    }

    .pj-table {
      min-width: 780px;
    }
  }

  @media (max-width: 430px) {
    .pj-filter-title {
      font-size: 14px;
    }

    .pj-filter-subtitle {
      font-size: 11px;
    }

    .pj-toolbar-right {
      align-items: stretch;
      flex-direction: column;
    }

    .pj-total-badge {
      justify-content: center;
    }
  }
`;

const normalizeArray = (value) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return [value];
  return [];
};

const formatTime = (value) => {
  if (!value) return "-";
  return String(value).slice(0, 5);
};

export default function PengaturanJam() {
  document.title = "Pengaturan Jam Absensi";

  const token = localStorage.getItem("token");
  const storageLevel = localStorage.getItem("level");

  const [loadingBranch, setLoadingBranch] = useState(false);
  const [loadingSemester, setLoadingSemester] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const [semesterList, setSemesterList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [schoolList, setSchoolList] = useState([]);
  const [data, setData] = useState([]);

  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [selectedData, setSelectedData] = useState();

  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });

  const firstLoadDone = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  useEffect(() => {
    const currentLevel = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];

    if (currentLevel === "developer" || currentLevel === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
      return;
    }

    setPermission({
      create: foundPermission.create,
      read: foundPermission.read,
      update: foundPermission.update,
      delete: foundPermission.delete,
    });
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const sortSchools = useCallback((schools) => {
    const order = ["SD", "SMP", "SMA"];

    return [...schools].sort((a, b) => {
      const nameA = (a?.school_name || "").toUpperCase();
      const nameB = (b?.school_name || "").toUpperCase();
      const indexA = order.findIndex((item) => nameA.includes(item));
      const indexB = order.findIndex((item) => nameB.includes(item));
      const safeA = indexA === -1 ? order.length : indexA;
      const safeB = indexB === -1 ? order.length : indexB;

      if (safeA !== safeB) return safeA - safeB;
      return nameA.localeCompare(nameB, "id");
    });
  }, []);

  const fetchBranches = useCallback(async () => {
    setLoadingBranch(true);

    try {
      const response = await APIMS.get(
        "/api/access/branches?page=1&limit=1000&ascending=1&search=",
        fetchParams
      );

      if (response?.status === 200) {
        const branches = response?.data?.data || [];
        setBranchList(branches);

        if (branches.length > 0) {
          setForm2((prev) => ({
            ...prev,
            ysb_branch_id: prev.ysb_branch_id || branches[0]?.branch_code || "",
          }));
        }
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data cabang",
      });
    } finally {
      setLoadingBranch(false);
    }
  }, [fetchParams]);

  const fetchSemesters = useCallback(async () => {
    setLoadingSemester(true);

    try {
      const response = await APIMS.get(
        "/api/access/semesters?page=1&limit=1000&ascending=1&search=",
        fetchParams
      );

      if (response?.status === 200) {
        const semesters = response?.data?.data || [];
        const activeSemester =
          semesters.find(
            (item) => item?.status === 1 || item?.status === "1" || item?.status === true
          ) || semesters[0];

        setSemesterList(semesters);

        if (activeSemester) {
          setForm2((prev) => ({
            ...prev,
            ysb_semester_id: prev.ysb_semester_id || activeSemester?.id || "",
          }));
        }
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data semester",
      });
    } finally {
      setLoadingSemester(false);
    }
  }, [fetchParams]);

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      if (!branchId) {
        setSchoolList([]);
        setForm2((prev) => ({ ...prev, ysb_school_id: "" }));
        return;
      }

      setLoadingSchool(true);

      try {
        const response = await APIMS.get(
          `/api/access/schools?page=1&limit=1000&ascending=1&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let schools = response?.data?.data || [];

          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter((item) => item?.ysb_branch_id === branchId);
          }

          if (branchId === "BKS") {
            schools = schools.filter(
              (item) => item?.school_code !== "BASEMENT_BEKASI"
            );
          }

          schools = sortSchools(schools);
          setSchoolList(schools);

          setForm2((prev) => ({
            ...prev,
            ysb_school_id: schools[0]?.school_code || "",
          }));
        }
      } catch (error) {
        setSchoolList([]);
        setForm2((prev) => ({ ...prev, ysb_school_id: "" }));
        ToastError.fire({
          icon: "error",
          title: error.response?.data?.message || "Gagal memuat data sekolah",
        });
      } finally {
        setLoadingSchool(false);
      }
    },
    [fetchParams, sortSchools, storageLevel]
  );

  useEffect(() => {
    fetchBranches();
    fetchSemesters();
  }, [fetchBranches, fetchSemesters]);

  useEffect(() => {
    if (form2.ysb_branch_id) {
      fetchSchoolsByBranch(form2.ysb_branch_id);
    }
  }, [fetchSchoolsByBranch, form2.ysb_branch_id]);

  const GetResponseData = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id
    ) {
      return;
    }

    setIsFetching(true);
    setSearchKeyword("");

    try {
      const response = await APISD.post(
        "/api/absen-config/request",
        {
          ysb_semester_id: form2.ysb_semester_id,
          level: storageLevel,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_school_id: form2.ysb_school_id,
        },
        fetchParams
      );

      if (response?.status === 200) {
        setData(normalizeArray(response?.data?.data));
      }
    } catch (error) {
      setData([]);

      if (error?.response?.status !== 404) {
        ToastError.fire({
          icon: "error",
          title: error.response?.data?.message || "Gagal memuat pengaturan jam",
        });
      }
    } finally {
      setIsFetching(false);
    }
  }, [fetchParams, form2, storageLevel]);

  useEffect(() => {
    const filterReady =
      !!form2.ysb_semester_id &&
      !!form2.ysb_branch_id &&
      !!form2.ysb_school_id &&
      !loadingSchool;

    if (!filterReady || firstLoadDone.current) return;

    firstLoadDone.current = true;

    (async () => {
      await GetResponseData();
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
    })();
  }, [
    GetResponseData,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_semester_id,
    loadingSchool,
  ]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm2((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "ysb_branch_id" ? { ysb_school_id: "" } : {}),
    }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  const isFilterFilled =
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id;

  const canSearch =
    isFilterFilled &&
    isFilterDirty &&
    !loadingBranch &&
    !loadingSemester &&
    !loadingSchool &&
    !isFetching;

  const handleCari = async () => {
    if (loadingSchool) {
      swal({
        title: "Mohon tunggu",
        text: "Data sekolah masih dimuat. Coba kembali sebentar lagi.",
        icon: "info",
        timer: 2200,
        buttons: false,
      });
      return;
    }

    if (!isFilterFilled) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan semester, cabang, dan sekolah sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setData([]);
    setHasSearched(false);

    await GetResponseData();
    setHasSearched(true);
    setIsFilterDirty(false);
  };

  const filteredData = useMemo(() => {
    const keyword = searchKeyword.trim().toLowerCase();
    const source = normalizeArray(data);

    if (!keyword) return source;

    return source.filter((item) => {
      const searchableValues = [
        item?.in_time,
        item?.out_time,
        item?.grace_period_in,
        item?.note,
      ];

      return searchableValues.some((value) =>
        String(value ?? "")
          .toLowerCase()
          .includes(keyword)
      );
    });
  }, [data, searchKeyword]);

  const totalRows = filteredData.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / Math.max(1, rowsPerPage)));

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword, data]);

  useEffect(() => {
    if (tablePage > totalPages) setTablePage(totalPages);
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const start = (tablePage - 1) * rowsPerPage;
    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, rowsPerPage, tablePage]);

  const pageNumbers = useMemo(() => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const pages = [1];
    const left = Math.max(2, tablePage - 1);
    const right = Math.min(totalPages - 1, tablePage + 1);

    if (left > 2) pages.push("...");
    for (let page = left; page <= right; page += 1) pages.push(page);
    if (right < totalPages - 1) pages.push("...");
    pages.push(totalPages);

    return pages;
  }, [tablePage, totalPages]);

  const goToPage = (page) => {
    const safePage = Math.min(Math.max(1, Number(page) || 1), totalPages);
    setTablePage(safePage);
  };

  const filterLoading = loadingBranch || loadingSemester || loadingSchool;

  return (
    <div className="module-page pj-page">
      <style>{pageStyles}</style>

      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          filterData={form2}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          filterData={form2}
          id={selectedId}
          dataUpdate={selectedData}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
        />
      )}

      <section className="pj-filter-card">
        <div className="pj-filter-header">
          {/* <div className="pj-filter-title-wrap">
            <span className="pj-filter-icon">
              <FontAwesomeIcon icon={faFilter} />
            </span>
            <div>
              <h3 className="pj-filter-title">Filter Pengaturan Jam</h3>
              <p className="pj-filter-subtitle">
                Pilih semester, cabang, dan sekolah untuk menampilkan data.
              </p>
            </div>
          </div> */}
        </div>

        {filterLoading ? (
          <div className="pj-filter-grid">
            {[1, 2, 3, 4].map((item) => (
              <div className="pj-field" key={item}>
                <div className="pj-shimmer pj-shimmer-label" />
                <div className="pj-shimmer pj-shimmer-control" />
              </div>
            ))}
          </div>
        ) : (
          <div className="pj-filter-grid">
            <div className="pj-field">
              <label className="pj-label" htmlFor="ysb_semester_id">
                Semester
              </label>
              <div className="pj-select-wrap">
                <select
                  id="ysb_semester_id"
                  className="pj-select"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                >
                  <option value="">Pilih Semester</option>
                  {semesterList.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name_year} (Semester {item?.semester})
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="pj-field">
              <label className="pj-label" htmlFor="ysb_branch_id">
                Cabang
              </label>
              <div className="pj-select-wrap">
                <select
                  id="ysb_branch_id"
                  className="pj-select"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                >
                  <option value="">Pilih Cabang</option>
                  {branchList.map((item) => (
                    <option key={item?.branch_code} value={item?.branch_code}>
                      {item?.branch_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="pj-field">
              <label className="pj-label" htmlFor="ysb_school_id">
                Sekolah
              </label>
              <div className="pj-select-wrap">
                <select
                  id="ysb_school_id"
                  className="pj-select"
                  name="ysb_school_id"
                  value={form2.ysb_school_id}
                  onChange={handleChange}
                  disabled={!form2.ysb_branch_id || loadingSchool}
                >
                  <option value="">
                    {loadingSchool ? "Memuat sekolah..." : "Pilih Sekolah"}
                  </option>
                  {schoolList.map((item) => (
                    <option key={item?.school_code} value={item?.school_code}>
                      {item?.school_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="pj-field">
              <span className="pj-label">&nbsp;</span>
              <button
                type="button"
                className="pj-filter-button"
                onClick={handleCari}
                disabled={!canSearch}
              >
                {/* <FontAwesomeIcon icon={faMagnifyingGlass} /> */}
                {isFetching ? "Mencari..." : "Tampilkan Data"}
              </button>
            </div>
          </div>
        )}
      </section>

      {isFetching ? (
        <div className="pj-loading-card">
          <div className="pj-loading-head" />
          <div className="module-table-scroll">
            {[1, 2, 3, 4, 5].map((item) => (
              <div className="pj-loading-row" key={item}>
                <div className="pj-shimmer pj-loading-line short" />
                <div className="pj-shimmer pj-loading-line medium" />
                <div className="pj-shimmer pj-loading-line medium" />
                <div className="pj-shimmer pj-loading-line medium" />
                <div className="pj-shimmer pj-loading-line medium" />
                <div className="pj-shimmer pj-loading-line action" />
              </div>
            ))}
          </div>
        </div>
      ) : (
        hasSearched && (
          <>
            <div className="pj-toolbar">
              <div className="pj-search-wrap">
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="pj-search-icon"
                />
                <input
                  className="pj-search-input"
                  type="text"
                  value={searchKeyword}
                  onChange={(event) => setSearchKeyword(event.target.value)}
                  placeholder="Cari jam atau catatan..."
                />
              </div>

              <div className="pj-toolbar-right">
                <span className="pj-total-badge">{totalRows} data</span>

                {!!permission.create && (
                  <button
                    type="button"
                    className="pj-add-button"
                    onClick={() => setModalAdd(true)}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    Atur Waktu
                  </button>
                )}
              </div>
            </div>

            <div className="module-table-card">
              <div className="module-table-scroll">
                <table className="module-table pj-table">
                  <thead>
                    <tr>
                      <th className="module-col-number">No</th>
                      <th className="pj-col-time">Jam Masuk</th>
                      <th className="pj-col-time">Jam Pulang</th>
                      <th className="pj-col-limit">Batas Waktu Masuk</th>
                      <th className="pj-col-note">Catatan</th>
                      <th className="module-col-action">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((row, index) => (
                        <tr key={row?.id || index}>
                          <td className="module-col-number">
                            <span className="module-number-badge">
                              {(tablePage - 1) * rowsPerPage + index + 1}
                            </span>
                          </td>
                          <td>
                            <span className="pj-time-badge">
                              <FontAwesomeIcon icon={faClock} />
                              {formatTime(row?.in_time)}
                            </span>
                          </td>
                          <td>
                            <span className="pj-time-badge">
                              <FontAwesomeIcon icon={faClock} />
                              {formatTime(row?.out_time)}
                            </span>
                          </td>
                          <td>
                            <span className="pj-limit-text">
                              {row?.grace_period_in ?? 0} menit
                            </span>
                          </td>
                          <td>
                            <span
                              className={
                                row?.note
                                  ? "module-secondary-text"
                                  : "module-muted-text"
                              }
                            >
                              {row?.note || "Tidak ada catatan"}
                            </span>
                          </td>
                          <td className="module-col-action">
                            <div className="module-action-wrap">
                              {!!permission.update ? (
                                <button
                                  type="button"
                                  className="module-action-button module-action-edit"
                                  title="Edit pengaturan jam"
                                  aria-label="Edit pengaturan jam"
                                  onClick={() => {
                                    setSelectedId(row?.id);
                                    setSelectedData(row);
                                    setModalUpdate(true);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faPenToSquare} />
                                </button>
                              ) : (
                                <span className="module-muted-text">-</span>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="module-empty-state">
                          Data pengaturan jam tidak ditemukan.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {totalRows > 0 && (
                <div className="module-pagination">
                  <div className="module-pagination-left">
                    <span className="module-page-info">
                      Menampilkan{" "}
                      <b>{Math.min((tablePage - 1) * rowsPerPage + 1, totalRows)}</b>
                      -<b>{Math.min(tablePage * rowsPerPage, totalRows)}</b> dari{" "}
                      <b>{totalRows}</b> data
                    </span>

                    <select
                      className="module-page-size"
                      value={rowsPerPage}
                      onChange={(event) => {
                        setRowsPerPage(Number(event.target.value) || 10);
                        setTablePage(1);
                      }}
                    >
                      <option value={10}>10 / halaman</option>
                      <option value={25}>25 / halaman</option>
                      <option value={50}>50 / halaman</option>
                      <option value={100}>100 / halaman</option>
                    </select>
                  </div>

                  <div className="module-pagination-right">
                    <button
                      type="button"
                      className="module-page-nav"
                      onClick={() => goToPage(tablePage - 1)}
                      disabled={tablePage <= 1}
                      aria-label="Halaman sebelumnya"
                    >
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </button>

                    <div className="module-page-numbers">
                      {pageNumbers.map((page, index) =>
                        page === "..." ? (
                          <span className="module-page-dots" key={`dots-${index}`}>
                            ...
                          </span>
                        ) : (
                          <button
                            type="button"
                            key={page}
                            className={`module-page-number ${
                              page === tablePage ? "active" : ""
                            }`}
                            onClick={() => goToPage(page)}
                          >
                            {page}
                          </button>
                        )
                      )}
                    </div>

                    <button
                      type="button"
                      className="module-page-nav"
                      onClick={() => goToPage(tablePage + 1)}
                      disabled={tablePage >= totalPages}
                      aria-label="Halaman berikutnya"
                    >
                      <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        )
      )}
    </div>
  );
}
